import React from "react";
import {Navigate, Route, Routes as ReactRoutes, useParams, useSearchParams} from "react-router-dom";
import {routeConfigs} from "../../navigation/routeConfig";
import Dashboard from "../../routes/Dashboard/Dashboard";
import OpenOrders from "../../routes/Orders/OpenOrders";
import Reports from "../../routes/Reports/Reports";
import Profile from "../../routes/Profile/Profile";
import PharmacyProfile from "../../routes/PharmacyProfile/PharmacyProfile";
import BankAccount from "../../routes/BankAccount/BankAccount";
import Pharmacies from "../../routes/Pharmacies/Pharmacies";
import Pharmacy from "../../routes/Pharmacies/Pharmacy/Pharmacy";
import SellList from "../../routes/Sell/SellList";
import NewSellItem from "../../routes/Sell/NewSellItem/NewSellItem";
import EditSellItem from "../../routes/Sell/EditSellItem/EditSellItem";
import Buy from "../../routes/Buy/Buy";
import Checkout from "../../routes/Checkout/Checkout";
import SellerListings from "../../routes/SellerListings/SellerListings";
import BuyHistory from "../../routes/BuyHistory/BuyHistory";
import SellHistory from "../../routes/SellHistory/SellHistory";
import Users from "../../routes/Users/Users";
import AddUser from "../../routes/Users/AddUser/AddUser";
import EditUser from "../../routes/Users/EditUser/EditUser";
import Wishlist from "../../routes/Wishlist/Wishlist";
import NewWishlistItem from "../../routes/Wishlist/NewWishlistItem";
import VacationMode from "../../routes/VacationMode/VacationMode";
import SettingsLayout from "../../routes/Settings/SettingsLayout";
import ComplianceVerification from "../../routes/Settings/ComplianceVerification";

interface IRoutes {
  isAdmin: boolean;
}

const LegacyBankAccountRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const qs = searchParams.toString();
  return (
    <Navigate
      to={`${routeConfigs.bankAccount.path}${qs ? `?${qs}` : ""}`}
      replace
    />
  );
};

const LegacyEditUserRedirect: React.FC = () => {
  const { id } = useParams();
  return <Navigate to={`/settings/users/${id}`} replace />;
};

const Routes:React.FunctionComponent<IRoutes> = ({
  isAdmin
}) => {
  return (
    <ReactRoutes>
      {isAdmin ? (
        <>
          <Route path={routeConfigs.buy.path} element={ <Navigate to={routeConfigs.pharmacies.path} /> } />
          <Route path={routeConfigs.pharmacies.path} element={<Pharmacies />} />
          <Route path={routeConfigs.pharmacy.path} element={<Pharmacy />} />
          <Route path={routeConfigs.postings.path} element={<SellList isAdmin />} />
          <Route path={routeConfigs.editSellItem.path} element={<EditSellItem isAdmin />} />
          <Route path={routeConfigs.sales.path} element={<BuyHistory isAdmin />} />
          <Route path={routeConfigs.orders.path} element={<SellHistory isAdmin />} />
          <Route path={routeConfigs.reports.path} element={<Reports />} />
          <Route path="*" element={<div>Not found</div>} />
        </>
      ) : (
        <>
          <Route path={routeConfigs.buy.path} element={<Buy />} />
          <Route path={routeConfigs.sell.path} element={<SellList />} />
          <Route path={routeConfigs.wishlist.path} element={<Wishlist />} />
          <Route path={routeConfigs.newWishlistItem.path} element={<NewWishlistItem />} />
          <Route path={routeConfigs.newSellItem.path} element={<NewSellItem />} />
          <Route path={routeConfigs.editSellItem.path} element={<EditSellItem />} />
          <Route path={routeConfigs.buyHistory.path} element={<BuyHistory />} />
          <Route path={routeConfigs.sellHistory.path} element={<SellHistory />} />
          <Route path={routeConfigs.openOrders.path} element={<OpenOrders />} />
          <Route path={routeConfigs.profile.path} element={<Profile />} />
          <Route path={routeConfigs.login.path} element={ <Navigate to={routeConfigs.buy.path} /> } />
          <Route path={routeConfigs.signUp.path} element={ <Navigate to={routeConfigs.buy.path} /> } />
          <Route path={routeConfigs.forgotPassword.path} element={ <Navigate to={routeConfigs.buy.path} /> } />
          <Route path={routeConfigs.settings.path} element={<SettingsLayout />}>
            <Route index element={<Navigate to={routeConfigs.pharmacyProfile.path} replace />} />
            <Route path="profile" element={<PharmacyProfile />} />
            <Route path="banking" element={<BankAccount />} />
            <Route path="users" element={<Users />} />
            <Route path="users/add" element={<AddUser />} />
            <Route path="users/:id" element={<EditUser />} />
            <Route path="compliance" element={<ComplianceVerification />} />
          </Route>
          <Route path="/pharmacy-profile" element={<Navigate to={routeConfigs.pharmacyProfile.path} replace />} />
          <Route path="/bank-account" element={<LegacyBankAccountRedirect />} />
          <Route path="/users" element={<Navigate to={routeConfigs.users.path} replace />} />
          <Route path="/users/add" element={<Navigate to={routeConfigs.addUser.path} replace />} />
          <Route path="/users/:id" element={<LegacyEditUserRedirect />} />
          <Route path={routeConfigs.checkout.path} element={<Checkout />} />
          <Route path={routeConfigs.sellerListings.path} element={<SellerListings />} />
          <Route path={routeConfigs.dashboard.path} element={<Dashboard />} />
          <Route path={routeConfigs.vacationMode.path} element={<VacationMode />} />
          <Route path="*" element={<div>Not found</div>} />
        </>
      )}
    </ReactRoutes>
  )
}

export default Routes;
